import { Card, Col, Row, Space, Button, Spin, Select, Tag } from "antd";
import "../assets/css/evidence.css";
import React from "react";
import { StoreContext } from "../store/RootStore";
import testImage from "../assets/images/st-distributor-rentcar.jpg";
import testImage2 from "../assets/images/st-main-carbg.jpg";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import TranscodedVideoPlayer from "./TranscodedVideoPlayer";
import SmartVideoPlayer from "./SmartVideoPlayer";
const { Option } = Select;

const cardData = [
    {
        id: 1,
        image: testImage,
        title: 'Vision: Following distance warning',
        dateTime: '16/07/2025 08:16:21 (AST)',
        vehicle: 'Toyota Fortuner - (ABC-L-1234) - 3372BND',
        fmg: 'FMG_Talal Saleh Alhusaini - 720560',
        note: 'less 50',
    },
    {
        id: 2,
        image: testImage2,
        title: 'Vision: Driver fatigue - yawning',
        dateTime: '16/07/2025 08:16:19 (AST)',
        vehicle: 'Toyota Fortuner - (ABC-L-1234) - 2785LTB',
        fmg: 'FMG_Faisal Al-dossari - 666871',
        note: 'Movement Alert (Event attached)',
    },
    {
        id: 3,
        image: testImage,
        title: 'Vision: Following distance warning',
        dateTime: '16/07/2025 08:16:21 (AST)',
        vehicle: 'Toyota Fortuner - (ABC-L-1234) - 3372BND',
        fmg: 'FMG_Talal Saleh Alhusaini - 720560',
        note: 'less 50',
    },
    {
        id: 4,
        image: testImage2,
        title: 'Vision: Driver fatigue - yawning',
        dateTime: '16/07/2025 08:16:19 (AST)',
        vehicle: 'Toyota Fortuner - (ABC-L-1234) - 2785LTB',
        fmg: 'FMG_Faisal Al-dossari - 666871',
        note: 'Movement Alert (Event attached)',
    },
    {
        id: 5,
        image: testImage,
        title: 'Vision: Following distance warning',
        dateTime: '16/07/2025 08:16:21 (AST)',
        vehicle: 'Toyota Fortuner - (ABC-L-1234) - 3372BND',
        fmg: 'FMG_Talal Saleh Alhusaini - 720560',
        note: 'less 50',
    },
    {
        id: 6,
        image: testImage2,
        title: 'Vision: Driver fatigue - yawning',
        dateTime: '16/07/2025 08:16:19 (AST)',
        vehicle: 'Toyota Fortuner - (ABC-L-1234) - 2785LTB',
        fmg: 'FMG_Faisal Al-dossari - 666871',
        note: 'Movement Alert (Event attached)',
    },
    {
        id: 7,
        image: testImage,
        title: 'Vision: Following distance warning',
        dateTime: '16/07/2025 08:16:21 (AST)',
        vehicle: 'Toyota Fortuner - (ABC-L-1234) - 3372BND',
        fmg: 'FMG_Talal Saleh Alhusaini - 720560',
        note: 'less 50',
    },
    {
        id: 8,
        image: testImage2,
        title: 'Vision: Driver fatigue - yawning',
        dateTime: '16/07/2025 08:16:19 (AST)',
        vehicle: 'Toyota Fortuner - (ABC-L-1234) - 2785LTB',
        fmg: 'FMG_Faisal Al-dossari - 666871',
        note: 'Movement Alert (Event attached)',
    },
    // Add more as needed
];
class EvidenceDetails extends React.Component {
    constructor(props, context) {
        super(props);
        const query = new URLSearchParams(this.props.location.search);
        this.evidenceStore = context.evidenceStore;
        this.state = {
            id: query.get("id"),
            channel: query.get("value"),
            alarmName: '',
            vehicleNo: '',
            driverName: '',
            alarmDate: '',
            model: '',
            sessionNo: query.get("session"),
            visibleEvidence: [],
            fromDate: query.get("fromDate"),
            toDate: query.get("toDate"),
            // alarmId: query.get("alarmId"),
        };
    }
    getEvidenceData = async (page = 0) => {
        console.log(this.state.alarmId)
        const data = {
            companyId: this.state.companyId,//1526,          
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
        };

        await this.evidenceStore.getEvidence(data, page);

        const evidence = this.evidenceStore.evidence; // full data from API

        console.log(evidence, "evidence")
        if (evidence && evidence.length > 0) {

            const filteredEvidence = await Promise.all(
                evidence.map(async (group) => {

                    const validRecords = await Promise.all(
                        group.records.map(
                            (item) =>
                                new Promise((resolve) => {
                                    if (!item.filename) {
                                        resolve(null);
                                        return;
                                    }

                                    const img = new Image();

                                    img.onload = () => resolve(item);
                                    img.onerror = () => resolve(null);

                                    img.src = item.filename;
                                })
                        )
                    );

                    return {
                        ...group,
                        records: validRecords.filter(Boolean)
                    };
                })
            );

            // Remove date groups having no valid records
            const finalEvidence = filteredEvidence.filter(
                group => group.records.length > 0
            );

            this.setState({
                page: 1,
                update: 1,
                visibleEvidence: finalEvidence.slice(0, this.state.itemsPerLoad),
                hasMore: finalEvidence.length > this.state.itemsPerLoad
            });
        } else {
            this.setState({
                visibleEvidence: [],
                hasMore: false
            });
        }
    };

    handleCardClick = async (item) => {
        console.log("item", item)
        await this.setState({
            // sessionNo: item.sessionNo,
            // alarmDate: item.startTime,
            // vehicleNo: item.vehicleNo,
            // driverName: item.driverName,
            // alarmName: item.alarmName,
            // model: item.model,
            // channel: item.value

            alarmDate: item.startTime,
            vehicleNo: item.vehicleNo,
            driverName: item.driverName,
            alarmName: item.alarmName,
            model: item.model,
            filename: item.filename,
            vdofilename: item.vdofilename,
        })
    };


    // renderEvidence(group) {
    //     console.log("object")
    //     const dateLabel = new Date(group.alarmDate).toLocaleDateString("en-US", {
    //         day: "numeric", month: "long", year: "numeric"
    //     });

    //     return (
    //         <div key={group.alarmDate} style={{ marginBottom: "24px" }}>
    //             {/* Date heading */}
    //             <p style={{ marginBottom: 16, fontSize: "16px", fontWeight: 600 }}>
    //                 {dateLabel}
    //             </p>

    //             <div className="evidence-list-details">
    //                 {group.records.map((item) => {
    //                     // console.log("item",item.sessionNo)
    //                     // console.log(`https://media.trackeazy.com/howendownloaded/test/multimedia#${item.sessionNo}-${item.value}`)
    //                     if (!item?.id || !item?.channel) {
    //                         console.warn("Skipping invalid record", item);
    //                         return null;
    //                     }

    //                     return (
    //                         <Card
    //                             key={`${item.id}-${item.channel}`}
    //                             hoverable
    //                             className="evidence-list-card"
    //                             onClick={() => this.handleCardClick(item)}
    //                         >
    //                             <div className="card-horizontal">
    //                                 {/* Video (left) */}
    //                                 {/* <div className="video-wrapper">
    //                                     <iframe
    //                                         src={`https://media.trackeazy.com/howendownloaded/test/multimedia#${item.sessionNo}-${item.value}`}
    //                                         frameBorder="0"
    //                                         allow="autoplay"
    //                                     />
    //                                 </div> */}

    //                                 <div className="video-wrapper">
    //                                     {item?.deviceId == 13 ?
    //                                         <img
    //                                             src={item.filename}
    //                                             alt={item.alarmName}
    //                                             style={{
    //                                                 width: "100%",
    //                                                 height: "100%",
    //                                                 objectFit: "cover", // or "contain"
    //                                                 display: "block"
    //                                             }}
    //                                             onError={(e) => {
    //                                                 e.currentTarget.parentElement.innerHTML =
    //                                                     "<div style='padding:20px;text-align:center'>Image not available</div>";
    //                                             }}
    //                                         /> :
    //                                         <iframe
    //                                             src={item.filename}
    //                                             frameBorder="0"
    //                                             allow="autoplay"
    //                                         />
    //                                     }


    //                                 </div>

    //                                 {/* Info (right) */}
    //                                 <div className="card-info">
    //                                     <div style={{ fontSize: "14px", fontWeight: 600 }}>
    //                                         Vision: {item.alarmName}
    //                                     </div>
    //                                     <div style={{ fontSize: "13px", color: "#555" }}>
    //                                         {item.startTime} (AST)
    //                                     </div>
    //                                     <div style={{ fontSize: "13px", color: "#444" }}>
    //                                         {item.model
    //                                             ? `${item.model} - (${item.vehicleNo})`
    //                                             : `(${item.vehicleNo})`}
    //                                     </div>
    //                                     <div style={{ fontSize: "13px", color: "#444" }}>
    //                                         {item.driverName ? item.driverName : "-"}
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </Card>
    //                     );
    //                 })}
    //             </div>
    //         </div>
    //     );
    // }

    renderEvidence(group) {
        console.log("object", group)


        const dateLabel = new Date(group.alarmDate).toLocaleDateString("en-US", {
            day: "numeric", month: "long", year: "numeric"
        });

        return (
            <div key={group.alarmDate} style={{ marginBottom: "24px" }}>
                {/* Date heading */}
                <p style={{ marginBottom: 16, fontSize: "16px", fontWeight: 600 }}>
                    {dateLabel}
                </p>

                <div className="evidence-list-details">
                    {group.records.map((item) => {

                        if (!item?.id) {
                            console.log("Skipping invalid record", item);
                            return null;
                        }



                        return (
                            <Card
                                key={item?.deviceId == 13 ? `${item.howenId}` : `${item.bsjId}`}
                                hoverable
                                className="evidence-list-card"
                                onClick={() => this.handleCardClick(item)}
                            >
                                <div className="card-horizontal">
                                    {/* Video (left) */}
                                    <div className="video-wrapper">
                                        {item?.deviceId == 13 ?
                                            <img
                                                src={item.filename}
                                                alt={item.alarmName}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover", // or "contain"
                                                    display: "block"
                                                }}
                                                onError={(e) => {
                                                    e.currentTarget.parentElement.innerHTML =
                                                        "<div style='padding:20px;text-align:center'>Image not available</div>";
                                                }}
                                            /> :
                                            <iframe
                                                src={item.filename}
                                                frameBorder="0"
                                                allow="autoplay"
                                            />
                                        }


                                    </div>

                                    {/* Info (right) */}
                                    <div className="card-info">
                                        <div style={{ fontSize: "14px", fontWeight: 600 }}>
                                            Vision: {item.alarmName}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#555" }}>
                                            {item.startTime}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#444" }}>
                                            {item.model
                                                ? `${item.model} - (${item.vehicleNo})`
                                                : `(${item.vehicleNo})`}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#444" }}>
                                            {item.driverName ? item.driverName : "-"}
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        );
                    })}
                </div>
            </div>
        );
    }


    async componentDidMount() {
        const data = {
            id: this.state.id,
        }
        const result = await this.evidenceStore.getDetailedVideo(data);

        console.log(result, "result")
        const query = new URLSearchParams(this.props.location.search);

        console.log("result", result);
        await this.setState({
            alarmName: result.alarmName,
            vehicleNo: result.vehicleNo,
            driverName: result.driverName,
            alarmDate: result.alarmDate,
            model: result.model,
            sessionNo: result.sessionNo,
            vdofilename: query.get("vdofilename"),
        });
        await this.getEvidenceData();

        const evidence = await this.evidenceStore.evidence;
        console.log("evidence", evidence);
        if (evidence && evidence.length > 0) {
            this.setState({
                page: 1,
                update: 1,
                visibleEvidence: evidence.slice(0, this.state.itemsPerLoad), // show first few groups
                hasMore: evidence.length > this.state.itemsPerLoad
            });
        } else {
            this.setState({
                visibleEvidence: [],
                hasMore: false
            });
        }

    }
    render() {
        const { alarmName, vehicleNo, driverName, alarmDate, model, sessionNo, channel, vdofilename } = this.state;

        console.log(this.state)
        return <>
            <div style={{ padding: 0 }}>
                <Row className="headerFixed" style={{ height: "50px" }}>
                    <Col span={12}>
                        <div className="heading">
                            {this.context.translate("_EVIDENCE_")}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="evidence-container">
                <div className="filter-toolbar-container">
                    <div className="filter-bar">
                        <div
                            style={{
                                fontSize: "14px",
                                fontWeight: 500,
                                color: "#000"
                            }}
                        >
                            <p>Replay Video from Trackeazy: Following {alarmName} that occured on {alarmDate} (AST) </p>

                        </div>

                    </div>
                </div>

                <div className="evidence-details">
                    <div>
                        <Card hoverable className="evidence-video-card">
                            <div>
                                {/* <iframe
                                    key={`evidence-video-${sessionNo}-${channel}`}
                                    src={`https://media.trackeazy.com/howendownloaded/test/multimedia#${sessionNo}-${channel}`}
                                    width="100%"
                                    height="550px"
                                    frameBorder="0"
                                /> */}
                                <video

                                    src={vdofilename}
                                    autoPlay
                                    muted
                                    controls
                                    playsInline
                                    style={{ width: '100%', height: "500px", background: '#000', objectFit: 'fill', maxHeight: "80%", display: "block", }}
                                />
                                {/* <TranscodedVideoPlayer src={vdofilename} /> */}
                                {/* <SmartVideoPlayer src={vdofilename} /> */}
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 4,
                                        marginLeft: 10
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "#000"
                                        }}
                                    >
                                        Vision: {alarmName}
                                    </div>
                                    <div style={{ fontSize: "13px", color: "#555" }}>
                                        Event time (OBC): {alarmDate} (AST)
                                    </div>
                                    <div style={{ fontSize: "13px", color: "#555" }}>
                                        Event Video Retrieval Time(GPS): {alarmDate} (AST)
                                    </div>
                                    <div style={{ fontSize: "13px", color: "#444" }}>
                                        {model
                                            ? `${model} - (${vehicleNo})`
                                            : `(${vehicleNo})`}
                                    </div>

                                </div>

                            </div>

                        </Card>
                    </div>
                    {console.log(this.state.visibleEvidence, "this.state.visibleEvidence")}

                    <div className="scrollable-panel">
                        <Row gutter={[16, 16]} className="evidence-details-grid">
                            {/* <p style={{ margin: '10px 0px 10px 10px', fontSize: '15px', fontWeight: 121 }}> 16 July 2025</p> */}
                            {this.state.visibleEvidence && this.state.visibleEvidence.length > 0
                                ? this.state.visibleEvidence.map(group => this.renderEvidence(group))
                                : (
                                    <Col span={24} style={{ textAlign: "center", padding: "50px 0", color: "#999" }}>
                                        No data available
                                    </Col>
                                )}
                            {/* {this.state.visibleEvidence && this.state.visibleEvidence.length > 0
                            ?this.state.visibleEvidence.map((item) => (
                                <Col key={item.id}>
                                    <Card
                                        hoverable
                                        style={{ width: "100%", height: 200, borderRadius: "5px" }} // adjust as needed
                                        bodyStyle={{ padding: 0 }} // remove internal padding
                                    >
                                        <div className="card-horizontal">
                                            <img
                                                src={item.image}
                                                alt="snapshot"
                                                style={{
                                                    width: '150px',
                                                    height: '200px',
                                                    objectFit: 'cover',
                                                    borderRight: '1px solid #f0f0f0',
                                                }}
                                            />
                                            <div className="card-info">
                                                <div style={{ fontSize: '14px', fontWeight: 500, marginBottom: '10px' }}>
                                                    {item.title}
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#444', marginBottom: 2 }}>{item.dateTime}</div>
                                                <div style={{ fontSize: '12px', color: '#666' }}>{item.vehicle}</div>
                                                <div style={{ fontSize: '12px', color: '#666' }}>{item.fmg}</div>
                                                <div style={{ fontSize: '12px', color: '#666' }}>{item.note}</div>
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            )):"No data found"} */}
                        </Row>

                    </div>

                </div>

            </div>


        </>;
    }
}
EvidenceDetails.contextType = StoreContext;
export default observer
    (withRouter(EvidenceDetails));
// export default withRouter(EvidenceDetails);